import { retrieveSelfMerchantGroupAdmin } from "@/services/merchantGroup/retrieveSelfMerchantGroupAdmin"

type MerchantGroupAdmin = {
  id: string
  email: string
  hasPassword: boolean
  displayEmail: string
  isStaffShadowUser: boolean
}

const merchantGroupAdmin = ref<MerchantGroupAdmin | null>(
  null
)

// This means the `whenever` watcher will only be created once, not in every component that calls `useMerchantGroupAdmin`
const useMerchantGroupAdminWatchers =
  createSharedComposable(() => {
    const { isLoggedInMerchantGroup } =
      useMerchantGroupAuth()

    whenever(
      () => isLoggedInMerchantGroup.value,
      async () => {
        const response =
          await retrieveSelfMerchantGroupAdmin()
        merchantGroupAdmin.value = response
      },
      { immediate: true }
    )

    return true // Needed until we update vueuse: https://github.com/vueuse/vueuse/commit/a24411ed23d3bc9e07ab7ea718a29c6de4a0bceb
  })

export const useMerchantGroupAdmin = () => {
  useMerchantGroupAdminWatchers()

  return readonly(merchantGroupAdmin)
}
